import { ref } from "vue";

export const peopleVariables = ref([
  {
    id: 1,
    name: "First Name",
    tag: "{{contact.firstname | default: 'there'}}",
    category: "people",
  },
  {
    id: 2,
    name: "Last Name",
    tag: "{{contact.lastname | default: ''}}",
    category: "people",
  },
  {
    id: 3,
    name: "Full Name",
    tag: "{{contact.fullname | default: 'there'}}",
    category: "people",
  },
  {
    id: 4,
    name: "Current Company",
    tag: "{{contact.company | default: ''}}",
    category: "people",
  },
  {
    id: 5,
    name: "Current Role",
    tag: "{{contact.jobtitle | default: ''}}",
    category: "people",
  },
  {
    id: 8,
    name: "Personal Phone Number",
    tag: "{{contact.phone | default: ''}}",
    category: "people",
  },
  {
    id: 9,
    name: "Personal Email",
    tag: "{{contact.personalemail | default: ''}}",
    category: "people",
  },
  {
    id: 10,
    name: "Work Email",
    tag: "{{contact.workemail | default: ''}}",
    category: "people",
  },
  {
    id: 11,
    name: "LinkedIn",
    tag: "{{contact.linkedin | default: ''}}",
    category: "people",
  },
  {
    id: 12,
    name: "Timezone",
    tag: "{{contact.timezone | default: ''}}",
    category: "people",
  },
  {
    id: 13,
    name: "Company HQ Location",
    tag: "{{contact.company_hq | default: ''}}",
    category: "people",
  },
  {
    id: 14,
    name: "Contact Status",
    tag: "{{contact.status | default: ''}}",
    category: "people",
  },
]);

export const senderVariables = ref([
  {
    id: 15,
    name: "Sender Name",
    tag: "{{sender.name | default: ''}}",
    category: "sender",
  },
  {
    id: 16,
    name: "Sender First Name",
    tag: "{{sender.firstname | default: ''}}",
    category: "sender",
  },
  {
    id: 17,
    name: "Sender Last Name",
    tag: "{{sender.lastname | default: ''}}",
    category: "sender",
  },
  {
    id: 18,
    name: "Sender Email",
    tag: "{{sender.email | default: ''}}",
    category: "sender",
  },
  {
    id: 19,
    name: "Sender Company",
    tag: "{{sender.company | default: ''}}",
    category: "sender",
  },
  {
    id: 20,
    name: "Sender Meeting URL",
    tag: "{{sender.meeting_link | default: 'Default Workspace Meeting Link'}}",
    category: "sender",
  },
]);

export const companyVariables = ref([
  {
    id: 21,
    name: "Company Name",
    tag: "{{company.name | default: ''}}",
    category: "company",
  },
  {
    id: 22,
    name: "Industry",
    tag: "{{company.industry | default: ''}}",
    category: "company",
  },
  {
    id: 23,
    name: "Website",
    tag: "{{company.website | default: ''}}",
    category: "company",
  },
  {
    id: 24,
    name: "Company Size",
    tag: "{{company.size | default: ''}}",
    category: "company",
  },
  {
    id: 25,
    name: "Annual Revenue",
    tag: "{{company.revenue | default: ''}}",
    category: "company",
  },
  {
    id: 26,
    name: "LinkedIn",
    tag: "{{company.linkedin | default: ''}}",
    category: "company",
  },
  {
    id: 27,
    name: "City",
    tag: "{{company.city | default: ''}}",
    category: "company",
  },
  {
    id: 28,
    name: "State",
    tag: "{{company.state | default: ''}}",
    category: "company",
  },
  {
    id: 29,
    name: "Country",
    tag: "{{company.country | default: ''}}",
    category: "company",
  },
  {
    id: 30,
    name: "Postal Code",
    tag: "{{company.postal_code | default: ''}}",
    category: "company",
  },
]);

export const allPersonalizeVariables = ref([
  ...peopleVariables.value,
  ...senderVariables.value,
  ...companyVariables.value,
]);

export const personalizeOptions = ref(allPersonalizeVariables.value);

export const personalizationTabs = [
  { id: "all", name: "All" },
  { id: "people", name: "People" },
  { id: "company", name: "Company" },
  { id: "sender", name: "Sender" },
];

export const limitedOptionsFilters = ref([
  {
    id: "first_name",
    name: "First Name",
    tag: "{{contact.firstname | default: 'there'}}",
    category: "people",
  },
  {
    id: "last_name",
    name: "Last Name",
    tag: "{{contact.lastname | default: ''}}",
    category: "people",
  },
  {
    id: "full_name",
    name: "Full Name",
    tag: "{{contact.fullname | default: 'there'}}",
    category: "people",
  },
  {
    id: "company_name",
    name: "Company Name",
    tag: "{{contact.company | default: ''}}",
    category: "people",
  },
  {
    id: "sender_company",
    name: "Sender Company",
    tag: "{{sender.company | default: ''}}",
    category: "sender",
  },
  {
    id: "unsubscribe",
    name: "Unsubscribe",
    tag: "{{unsubscribe_url}}",
    category: "sender",
    isLink: true,
  },
]);

export const transformCustomPropertiesToVariables = (
  customProperties,
  category,
  entityPrefix,
) => {
  return customProperties.map((property) => ({
    id: 1000 + property.id,
    name: property.name,
    tag: `{{${entityPrefix}.${property.slug} | default: ''}}`,
    category: category,
    isCustom: true,
    slug: property.slug,
    datatype: property.datatype || property.type,
  }));
};

export const addPersonalizationOption = (option) => {
  allPersonalizeVariables.value.push(option);

  if (option.category === "people") {
    peopleVariables.value.push(option);
  } else if (option.category === "company") {
    companyVariables.value.push(option);
  } else if (option.category === "sender") {
    senderVariables.value.push(option);
  }

  personalizeOptions.value = allPersonalizeVariables.value;
};

export const emailDirections = {
  SENT: "SENT",
  RECEIVED: "RECEIVED",
};

export const emailSendingLimits = {
  MAX_DAILY_LIMIT: 250,
  MAX_HOURLY_LIMIT: 50,
  MIN_EMAIL_DELAY_SECONDS: 60,
  DEFAULT_DAILY_LIMIT: 35,
  DEFAULT_HOURLY_LIMIT: 6,
  DEFAULT_EMAIL_DELAY_SECONDS: 600,
};

export const sendingLimitsData = {
  EMAILS_SENT_PER_DAY: {
    description:
      "Recommended daily limit: 50, or 50+ if you're sending campaigns with a > 5% reply rate and have a high domain reputation.",
    tooltip:
      "The emails sent per day (daily limit) is the maximum number of emails you can send per mailbox within a 24- hour period. This calculation may vary depending on your email service provider (ESP).",
  },
  EMAILS_SENT_PER_HR: {
    description: "Recommended hourly limit: 6 emails.",
    tooltip:
      "This is the time (in seconds) between sending consecutive emails. This helps ensure compliance, prevent spam, and maintain a good sender reputation.",
  },
};

export const emailStages = {
  DELIVERED: "DELIVERED",
  OPENED: "OPENED",
  CLICKED: "CLICKED",
  REPLIED: "REPLIED",
  BOUNCED: "BOUNCED",
};

export const engagementTooltipTypes = {
  DELIVERED: "delivered",
  OPENED: "opened",
  CLICKED: "clicked",
  REPLIED: "replied",
  SENT: "sent",
  ACCEPTED: "accepted",
};

export const quillUnsupportedTags = [
  "table",
  "tr",
  "td",
  "th",
  "thead",
  "tbody",
  "tfoot",
  "div",
  "span",
  "section",
  "article",
  "aside",
  "header",
  "footer",
  "nav",
  "main",
  "figure",
  "figcaption",
  "details",
  "summary",
  "canvas",
  "svg",
  "video",
  "audio",
  "iframe",
  "embed",
  "object",
  "form",
  "input",
  "button",
  "select",
  "textarea",
  "label",
  "fieldset",
  "legend",
  "datalist",
  "output",
  "progress",
  "meter",
];

export const emailDomainBlockListHeaders = [
  { label: "Domain/Email", key: "domain", width: 6 },
  { label: "Added on", key: "added_on", width: 3 },
  { label: "", key: "actions", width: 3 },
];
